export default function AlertsFilter($filter) {
	'ngInject';

	return function(data, status, priority, faults, searchText) {
		var temp = [];

		if (priority === 'any' && status === 'any' && faults === 'any') {
			temp = data.slice();
		} else {
			for (var i = 0; i < data.length; ++i) {
				if (
					priority.includes(data[i].priority) &&
					status.includes('any') &&
					faults.includes('any')
				) {
					temp.push(data[i]);
				}
				if (
					priority.includes('any') &&
					status.includes(data[i].status) &&
					faults.includes('any')
				) {
					temp.push(data[i]);
				}
				if (
					priority.includes(data[i].priority) &&
					status.includes(data[i].status) &&
					faults.includes('any')
				) {
					temp.push(data[i]);
				}

				if (
					priority.includes('any') &&
					status.includes('any') &&
					faults.includes('Alerts')
				) {
					if (
						!data[i].series.tags[0].includes('dtc') &&
						data[i].series.tags[0] !== 'gps'
					) {
						temp.push(data[i]);
					}
				}

				if (
					priority.includes('any') &&
					status.includes('any') &&
					faults.includes('Faults')
				) {
					if (data[i].series.tags[0].includes('dtc')) {
						temp.push(data[i]);
					}
				}

				if (
					priority.includes('any') &&
					status.includes('any') &&
					faults.includes('Geozones')
				) {
					if (data[i].series.tags[0] === 'gps') {
						temp.push(data[i]);
					}
				}

				if (
					priority.includes('any') &&
					status.includes(data[i].status) &&
					faults.includes('Alerts')
				) {
					if (
						!data[i].series.tags[0].includes('dtc') &&
						data[i].series.tags[0] !== 'gps'
					) {
						temp.push(data[i]);
					}
				}

				if (
					priority.includes('any') &&
					status.includes(data[i].status) &&
					faults.includes('Faults')
				) {
					if (data[i].series.tags[0].includes('dtc')) {
						temp.push(data[i]);
					}
				}

				if (
					priority.includes('any') &&
					status.includes(data[i].status) &&
					faults.includes('Geozones')
				) {
					if (data[i].series.tags[0] === 'gps') {
						temp.push(data[i]);
					}
				}

				if (
					priority.includes(data[i].priority) &&
					status.includes('any') &&
					faults.includes('Alerts')
				) {
					if (
						!data[i].series.tags[0].includes('dtc') &&
						data[i].series.tags[0] !== 'gps'
					) {
						temp.push(data[i]);
					}
				}

				if (
					priority.includes(data[i].priority) &&
					status.includes('any') &&
					faults.includes('Faults')
				) {
					if (data[i].series.tags[0].includes('dtc')) {
						temp.push(data[i]);
					}
				}

				if (
					priority.includes(data[i].priority) &&
					status.includes('any') &&
					faults.includes('Geozones')
				) {
					if (data[i].series.tags[0] === 'gps') {
						temp.push(data[i]);
					}
				}

				if (
					priority.includes(data[i].priority) &&
					status.includes(data[i].status) &&
					faults.includes('Alerts')
				) {
					if (
						!data[i].series.tags[0].includes('dtc') &&
						data[i].series.tags[0] !== 'gps'
					) {
						temp.push(data[i]);
					}
				}

				if (
					priority.includes(data[i].priority) &&
					status.includes(data[i].status) &&
					faults.includes('Faults')
				) {
					if (data[i].series.tags[0].includes('dtc')) {
						temp.push(data[i]);
					}
				}

				if (
					priority.includes(data[i].priority) &&
					status.includes(data[i].status) &&
					faults.includes('Geozones')
				) {
					if (data[i].series.tags[0] === 'gps') {
						temp.push(data[i]);
					}
				}
			}
		}
		if (searchText) {
			temp = $filter('filter')(temp, searchText);
		}

		return temp;
	};
}
